import { buildAdjustSummary } from './StepPendingToolCall/ConditionReviewList/ConditionReviewList.constants';

export const STEP_CONFIRMATION_LABELS = {
  PROMPT: 'This step is awaiting your confirmation.',
  CONFIRM: 'Confirm',
  CONFIRM_AND_ADD: ({ count }) => `Confirm & add ${count}`,
  REJECT: 'Reject',
  REJECT_ALL: 'Reject all',
  ADJUST_SUMMARY: buildAdjustSummary,
  REASON_PLACEHOLDER: 'Reason (optional)',
  REASON_SUBMIT: 'Confirm rejection',
  REASON_CANCEL: 'Cancel',
  SLA_GROUP_LABEL: 'SLA group',
  SLA_GROUP_PLACEHOLDER: 'Choose an SLA group',
  SLA_GROUP_PROMPT: 'Choose an SLA group for the conditions before confirming.',
};

export const STEP_CONFIRM_LABELS = {
  approve: STEP_CONFIRMATION_LABELS.CONFIRM,
  dismiss: STEP_CONFIRMATION_LABELS.REJECT,
  reasonPlaceholder: STEP_CONFIRMATION_LABELS.REASON_PLACEHOLDER,
  reasonSubmit: STEP_CONFIRMATION_LABELS.REASON_SUBMIT,
  reasonCancel: STEP_CONFIRMATION_LABELS.REASON_CANCEL,
  slaGroupLabel: STEP_CONFIRMATION_LABELS.SLA_GROUP_LABEL,
  slaGroupPlaceholder: STEP_CONFIRMATION_LABELS.SLA_GROUP_PLACEHOLDER,
  slaGroupPrompt: STEP_CONFIRMATION_LABELS.SLA_GROUP_PROMPT,
};

export const StepConfirmationTestIds = {
  CONTAINER: 'AiActivity_StepConfirmation_Container',
  ADJUST_SUMMARY: 'AiActivity_StepConfirmation_AdjustSummary',
};
